import clsx from "clsx"

import type { PropsWithClassName } from "~/@types/generics"
import type { TProductCtaReinsurance } from "~/components/ui/ProductHeader/components/ProductDetails/components/ProductCtaReinsurance/_data/get"

import * as css from "./styles.css"

export function ProductCtaReinsurance({
  text,
  color,
  textColor,
  className,
}: PropsWithClassName<TProductCtaReinsurance>) {
  return (
    <div className={clsx(css.ProductCtaReinsurance, className)} style={{ backgroundColor: color }}>
      <p className={css.textTitle} style={{ color: textColor }}>
        {text}
      </p>
    </div>
  )
}
